<template>
  <draggable
    :list="options"
    class="list-group"
    ghost-class="ghost"
    @start="dragging = true"
    @end="dragging = false"
  >
    <v-layout
      align-center
      class="mb-2 ml-1 text-xs-left"
      :key="i"
      v-for="(option, i) in options"
    >
      <v-icon class="mr-2" style="cursor: pointer"> drag_handle </v-icon>
      <template v-if="isEditable(i)">
        <v-text-field v-model="textToEdit" />
      </template>
      <template v-else>
        <template v-if="useLetter">
          {{ toLetters(i + 1) }}. {{ getDisplayName(option) }}
        </template>
        <template v-else> {{ i + 1 }}. {{ getDisplayName(option) }} </template>
      </template>
      <template v-if="isEditable(i)">
        <v-icon
          color="primary"
          style="cursor: pointer"
          size="20"
          class="ml-2"
          @click="confirmEdition()"
        >
          done
        </v-icon>
        <v-icon
          color="error"
          style="cursor: pointer"
          size="20"
          class="ml-2"
          @click="cancelEdition()"
        >
          cancel
        </v-icon>
      </template>
      <template v-else>
        <v-icon
          color="primary"
          v-if="editOption === null"
          style="cursor: pointer"
          size="20"
          class="ml-2"
          @click="setEditOption(i, getDisplayName(option))"
        >
          mode
        </v-icon>
        <v-icon
          color="error"
          style="cursor: pointer"
          size="20"
          class="ml-2"
          @click="deleteOption(i)"
        >
          delete_outline
        </v-icon>
      </template>
    </v-layout>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  name: 'MultipleOptions',
  components: {
    draggable,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    optionsEditing: {
      type: Boolean,
      default: false,
    },
    optionLabel: {
      type: String,
      default: null,
    },
    useLetter: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      options: [],
      dragging: false,
      editOption: null,
      textToEdit: null,
    };
  },
  watch: {
    value(newVal) {
      this.options = newVal;
    },
  },
  methods: {
    setEditOption(idx, text) {
      this.textToEdit = text;
      this.editOption = idx;
      this.$emit('update:optionsEditing', true);
    },
    cancelEdition() {
      this.editOption = null;
      this.$emit('update:optionsEditing', false);
    },
    getDisplayName(option) {
      return this.optionLabel ? option[this.optionLabel] : option;
    },
    deleteOption(idx) {
      this.options.splice(idx, 1);
      this.$emit('input', this.options);
    },
    isEditable(idx) {
      return this.editOption !== null && this.editOption === idx;
    },
    confirmEdition() {
      let oldText = this.options[this.editOption];
      if (this.optionLabel) {
        this.options[this.editOption][
          this.optionLabel
        ] = this.textToEdit.trim();
      } else {
        this.options[this.editOption] = this.textToEdit.trim();
      }
      this.$emit('input', this.options);
      this.$emit('changed', oldText, this.textToEdit);
      this.$emit('update:optionsEditing', false);
      this.editOption = null;
    },
    toLetters(num) {
      let mod = num % 26;
      let pow = (num / 26) | 0;
      let out = mod ? String.fromCharCode(64 + mod) : (--pow, 'Z');

      return pow ? this.toLetters(pow) + out : out;
    },
  },
  created() {
    this.options = this.value;
  },
};
</script>

<style scoped></style>
